import type { PluginFunc } from 'dayjs'

import _d from 'dayjs'
import { isNaN, isNumber } from 'lodash-es'

export interface Dayjs extends _d.Dayjs {
  formatDate: (format?: string) => string
}

const plugin: PluginFunc = (_, dayjsClass) => {
  // @ts-ignore xxx
  dayjsClass.prototype.formatDate = function (
    format: string = 'YYYY-MM-DD HH:mm:ss',
  ) {
    return this.format(format)
  }
}

_d.extend(plugin)

export const dayjs = (...args: Parameters<typeof _d>) => {
  if (args.length === 1 && (isNumber(args[0]) || !isNaN(Number(args[0])))) {
    // @ts-nocheck xxx
    return _d(Number(args[0])) as Dayjs
  }
  return _d(...args) as Dayjs
}
